import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, User, BrainCircuit } from "lucide-react";

import logo from "../assets/favicro.png";

const LabNavbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.clear(); // Clear all local storage
    navigate("/login"); // Redirect to login
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Check if current page should show Home button
  const showHomeButton = [
    "/chemist_dashboard",
    "/lab_tests",
    "/lab_reports",
    "/profile",
  ].includes(location.pathname);

  return (
    <nav className="bg-white shadow-md px-6 py-3 flex justify-between items-center">
      {/* Logo */}
      <div className="flex items-center gap-2 text-2xl font-bold text-blue-600">
        <img
          src={logo}
          alt="AICA Logo"
          className="w-8 h-8 object-contain"
        />
        <span>
          AICA<span className="text-gray-700"> | Chemist</span>
        </span>
      </div>

      {/* Right Side */}
      <div className="flex items-center gap-6">
        {/* Lab Dashboard Link */}
        {location.pathname !== "/chemist_dashboard" && (
          <button
            onClick={() => navigate("/chemist_dashboard")}
            className="flex items-center gap-2 text-gray-700 hover:text-blue-600"
          >
            <BrainCircuit className="w-5 h-5 text-blue-500" />
            <span className="hidden sm:inline">Chemist Dashboard</span>
          </button>
        )}

        {/* Profile Dropdown */}
        <div className="relative" ref={dropdownRef}>
          <button
            className="flex items-center gap-2 text-gray-700 hover:text-blue-600"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <User className="w-5 h-5" />
            <span className="hidden sm:inline">{localStorage.getItem("chemist_name") || "Chemist User"}</span>
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-40 bg-white border rounded-lg shadow-lg p-2 z-50">
              {/* {showHomeButton && (
                <button
                  onClick={() => navigate("/lab_dashboard")}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded"
                >
                  Home
                </button>
              )} */}
              {location.pathname !== "/profile" && (
                <button
                  onClick={() => navigate("/profile")}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded"
                >
                  Profile
                </button>
              )}
              <button
                onClick={handleLogout}
                className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-100 rounded flex items-center gap-2"
              >
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default LabNavbar;
